import reducer, { initialState } from 'store/v2/index';
import actionType from './constants';

const payload = {
  ...initialState(),
};

export default reducer(actionType, payload);
